
var url = window.location.origin

// Baked in at build time: REACT_APP_API_URL=https://api.example.in yarn build
// It must win over every mapping below — a production build served from a hostname that is not
// in the list would otherwise fall through to CDAT's API, which is the one thing a self-hosted
// deployment must never do.
var explicitApi = process.env.REACT_APP_API_URL

// Local / self-hosted deployments with no explicit override talk to our own Java API on 8081.
var localApi = "http://" + window.location.hostname + ":8081"
var isLocal = /^https?:\/\/(localhost|127\.0\.0\.1|0\.0\.0\.0|13\.232\.135\.198)(:\d+)?$/.test(url)

export const BaseUrl =
    explicitApi ? explicitApi :
    isLocal ? localApi :
    url === "http://amchimulgi-maha.in" ? "http://api.amchimulgi-maha.in" :
        url === "http://amchimulgimaha.in" ? "http://api.amchimulgimaha.in" :
            url === "https://amchimulgimaha.in" ? "https://api.amchimulgimaha.in" :
                url === "http://demo.amchimulgimaha.in" ? "http://apidemo.amchimulgimaha.in" :
                    url === "https://amchimulgimaha.cdat.work" ? "https://apiamchimulgimaha.cdat.work" :
                        "https://apiamchimulgimaha.cdat.work"
// "http://amchimulagiapi.cdatinfotech.com"
// "http://apidemo.amchimulgimaha.in"
// "http://api.amchimulgimaha.in"